import gql from 'graphql-tag';

export const GET_CARECONNECT_CLIENTS = gql`
  query GetClientScheduleSummaries($input: ClientScheduleSummaryInput!) {
    getClientScheduleSummaries(input: $input) {
      clientSchedules {
        acceptedSchedule {
          dayOfWeek
          times
        }
        client {
          id
          name
          salesForceId
        }
        clinic {
          abbreviation
          address {
            addressLine1
            addressLine2
            city
            country
            name
            state
          }
          id
          name
          timezone
        }
        remainingSchedule {
          dayOfWeek
          times
          opensOn
          hasNonBTBooking
        }
        remainingScheduleRaw {
          dayOfWeek
          startTime
          endTime
          opensOn
        }
        remainingScheduleForUI {
          dayOfWeek
          times
          opensOn
          hasNonBTBooking
        }
        scheduled {
          dayOfWeek
          times
        }
        pendingScheduled {
          dayOfWeek
          times
        }
        scheduledForUI {
          dayOfWeek
          times
        }
        upcomingOpenings {
          dayOfWeek
          times
          opensOn
        }
        earliestOpeningDate
        hasAcceptedBlocks
        status
        waitlistedReason
        recommended
        insurancePlan {
          id
          name
          isVBC
        }
      }
      partiallyScheduledClientsCount
      unScheduledClientsCount
      count
    }
  }
`;

export const GET_SHIFT_DROPDOWN_OPTIONS = gql`
  query GetShiftDropdownOptions {
    getShiftDropdownOptions {
      shiftId
      description
      blocks {
        id
      }
    }
  }
`;
